/**
 * NearestHighwaysList component for Commercial PDP.
 * Displays a list of nearby highways/interstates with distance badges.
 * Items are expected to be pre-sorted by distance (nearest first).
 */
/* eslint-disable react/prop-types */
const NearestHighwaysList = ({ highways = [] }) => {
  if (!Array.isArray(highways) || highways.length === 0) {
    return (
      <div className="nearest-highways-list nearest-highways-list--empty">
        <p className="nearest-highways-list__empty-message">No nearby highways found</p>
      </div>
    );
  }

  return (
    <div className="nearest-highways-list">
      <div className="nearest-highways-list__heading">
        <img
          src="/assets/images/pdp/nearestHighway.png"
          alt=""
          aria-hidden="true"
          className="nearest-highways-list__heading-icon-img"
        />
        <h4 className="nearest-highways-list__heading-text">Nearest Highways</h4>
      </div>
      <ul className="nearest-highways-list__items">
        {highways.map((highway, index) => {
          const distanceRounded = Number(highway.distance).toFixed(1);
          const isNearby = highway.distance < 5;

          return (
            <li key={index} className="nearest-highways-list__item">
              <span className="nearest-highways-list__name">{highway.name}</span>
              <span className="nearest-highways-list__badge">
                <span className="nearest-highways-list__distance">{distanceRounded} mi</span>
                {isNearby && (
                  <span className="nearest-highways-list__nearby-label">Nearby</span>
                )}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default NearestHighwaysList;
